<template>
    <div>
        <div class="banner hidden-sm-and-down"> 
           <div class="iflogo">
               <img src="../assets/homeLogo/iflogo.jpeg" alt="" 
                 style="width:200px;height:60px;"> 
           </div>
           <div class="content">
            <h3 class="content-title">ifurniture, Curtain Specialist</h3>
             <p style="margin-bottom:5%">Don't just like your windows, love them. Treat them to a pair 
                 of made-to-measure curtains for a luxurious look that practical too.</p>
           </div>
        </div>
          
        <div class="hidden-sm-and-down" style="width:100%;">
           <h2>Online Curtain Quotation - Easy & Free</h2>
        </div>
      <div class="hidden-md-and-up">
          <img src="../assets/homeLogo/iflogo.jpeg" alt="" 
                 style="width:100px;height:30px;margin-right:70%;margin-top:20px;"> 
            <h4>Online Curtain Quotation - Easy & Free</h4>
      </div>
      <div>
         <el-form ref="userInfo" :model="userInformation" :rules="userInfoRules"  auto-complete="on">
             <el-row :gutter="20">
                 <el-col :lg="2" :xl="2" :md="1">
                   <el-form-item prop="Name" >
                   </el-form-item>
                 </el-col>
                <el-col :lg="4" :xl="4" :sm="12" :md="4" :xs="12">
                   <el-form-item prop="Name" label="Name">
                   <el-input v-model="userInformation.Name" name="Name" type="text" auto-complete="on" 
                   placeholder="Name" ref="name" @focus="focusName" />
                   </el-form-item>
                 
                 </el-col>
                
                 <el-col :lg="6" :xl="6" :sm="12" :md="6" :xs="12">
                  <el-form-item prop="Email" label="Email">
                  <el-input v-model="userInformation.Email" name="Email" type="text" auto-complete="on" 
                  placeholder="Email" ref="email" @focus="focusEmail"/>
                  </el-form-item>
                 </el-col>
                
                 <el-col :lg="4" :xl="4" :sm="12" :md="4" :xs="12">
                   <el-form-item prop="PhoneNumber" label="Phone Number">
                   <el-input v-model="userInformation.PhoneNumber" name="PhoneNumber" type="text" auto-complete="on" placeholder="Phone Number" />
                   </el-form-item>
                 
                 </el-col>
                
                 <el-col :lg="6" :xl="6" :sm="12" :md="6" :xs="12">
                  <el-form-item prop="Address" label="Address">
                  <el-input v-model="userInformation.Address" name="Address" type="text" auto-complete="on" placeholder="Address" />
                  </el-form-item>
                 </el-col>
                </el-row>
                <el-row style="text-align:left">
                  <el-col :offset="2" :lg="20" :xl="20" :sm="20" :md="20" :xs="20" class="hidden-sm-and-down">
                      <el-card class="box-card">
                        <div>
                      Summary: {{numOfCusMadeBlinds}} custom made blinds, {{numOfCusMadeCurtains-numOfNeedConfirmCurtains}} custom made curtains and {{numOfReadyMadeCurtains}} ready made curtains. 
                      
                        </div>
                        <div style="margin-top:10px;">
                          <span style="font-weight:bold; margin-top:10px;">Total cost: ${{totalPrice}}. Lock the price by saving the quotation (A PDF document can be downloaded) or emailing it to yourself. We guarantee the price for 7 days.</span> 
                        </div>
                        </el-card>
                      
                 </el-col>
                 <el-col :md="24" :xs="24" class="hidden-md-and-up">
                      <el-card class="box-card">
                        <div class="summary">
                           Summary: {{numOfCusMadeBlinds}} custom made blinds, {{numOfCusMadeCurtains-numOfNeedConfirmCurtains}} custom made curtains and {{numOfReadyMadeCurtains}} ready made curains. 
                       </div>
                        <div style="margin-top:10px;">
                          <span style="font-weight:bold; margin-top:10px;">Total cost: ${{totalPrice}}. Lock the price by saving the quotation (A PDF document can be downloaded) or emailing it to yourself. We guarantee the price for 7 days.</span> 
                        </div>
                        </el-card>
                      
                 </el-col>
                </el-row>
                <el-row>
                  <el-dialog
                       title="Confirm and Save"
                        :visible.sync="dialogVisiblelg"
                        width="300"
                          style="text-align:left" class="hidden-sm-and-down">
                       <div class="summary">
                           Summary: {{numOfCusMadeBlinds}} custom made blinds, {{numOfCusMadeCurtains-numOfNeedConfirmCurtains}} custom made curtains and {{numOfReadyMadeCurtains}} ready made curains. 
                       </div>
                       <div style="margin-top:10px;">
                          <span style="font-weight:bold; margin-top:10px;">Total cost: ${{totalPrice}}. Lock the price by saving the quotation (A PDF document can be downloaded) or emailing it to yourself. We guarantee the price for 7 days.</span> 
                        </div>
                         <span slot="footer" class="dialog-footer">
                          <!-- <el-button @click="dialogVisible = false">Cancle</el-button> -->
                          
                          <el-button type="primary" @click="saveQuotationAsPDF">Save to Local</el-button>
                           <el-button type="primary" @click="EmailQuotation">Email Me</el-button>
                         </span>
                    </el-dialog>
                  <el-dialog
                       title="Confirm and Save"
                        :visible.sync="dialogVisible"
                        width="80%"
                          style="text-align:left" class="hidden-md-and-up">
                       <div class="summary">
                           Summary: {{numOfCusMadeBlinds}} custom made blinds, {{numOfCusMadeCurtains-numOfNeedConfirmCurtains}} custom made curtains and {{numOfReadyMadeCurtains}} ready made curains. 
                       </div>
                       <div style="margin-top:10px;">
                          <span style="font-weight:bold; margin-top:10px;">Total cost: ${{totalPrice}}. Lock the price by saving the quotation (A PDF document can be downloaded) or emailing it to yourself. We guarantee the price for 7 days.</span> 
                        </div>
                         <span slot="footer" class="dialog-footer">
                          <!-- <el-button @click="dialogVisible = false">Cancle</el-button> -->
                          
                          <el-button type="primary" @click="saveQuotationAsPDF">Save to Local</el-button>
                           <el-button type="primary" @click="EmailQuotation">Email Me</el-button>
                         </span>
                    </el-dialog>

           
                    <el-col class="hidden-md-and-up">
                      <el-button type="primary" @click="dialogVisible = true">Save Quotation</el-button>
                      <a :href="quotationPDF" target="_blank" v-show="this.$store.state.quotationSaved && !this.$store.state.curtainChanged" style="display: block;" >If your browser didn't open the quotation automatically, plesae click here to get it. </a>
                  </el-col>
                     <el-col class="hidden-sm-and-down">
                      <el-button type="primary" @click="dialogVisiblelg = true">Save Quotation</el-button>
                       <a :href="quotationPDF" target="_blank" v-show="this.$store.state.quotationSaved && !this.$store.state.curtainChanged" style="display: block;" >If your browser didn't open the quotation automatically, plesae click here to get it. </a>
                    </el-col>
                </el-row>
             
              
         </el-form>
         </div>
         
    </div>
</template>

<script>
//:cusMadeBlinds="cusMadeBlinds"
//  :cusMadeCurtains="cusMadeCurtains" :readyMadeCurtains="readyMadeCurtains"
import { isvalidEmail } from "@/utils/validate";
import { saveQuotationPDF } from "@/api/SaveQuotationPDF";
import { regCustomer } from "@/api/RegCustomer";
import { emailQuotationPDF } from "@/api/EmailQuotationPDF";
import { getCurtainQuoationId } from "@/api/GetCurtainQuoationId";
import { addCurtainLists } from "@/api/AddCurtain";
export default {
  name: "UserInfo",
  props: ["userInfo", "cusMadeBlinds", "cusMadeCurtains", "readyMadeCurtains"],
  data() {
    const validateUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Please input your Name"));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (value && !isvalidEmail(value)) {
        callback(new Error("please input correct Email address"));
      } else {
        callback();
      }
    };
    return {
      quotationPDF: "",
      curtainList: [],
      userInformation: this.userInfo,
      cusMadeBlindsData: this.cusMadeBlinds,
      cusMadeCurtainsData: this.cusMadeCurtains,
      readyMadeCurtainsData: this.readyMadeCurtains,
      userInfoRules: {
        Name: [
          { required: true, trigger: "blur", validator: validateUserName }
        ],
        Email: [{ required: false, trigger: "blur", validator: validateEmail }]
      },
      dialogVisible: false,
      dialogVisiblelg:false,
    };
  },

  computed: {
    numOfCusMadeBlinds() {
      return this.cusMadeBlindsData.filter(item => item.Price > 0).length;
    },
    numOfCusMadeCurtains() {
      let count = 0;
      this.cusMadeCurtainsData.forEach(item => {
        if (
          item.Width > 0 &&
          item.Width <= 1000 &&
          item.Drop > 0 &&
          item.Drop <= 270 &&
          item.Type !== "" &&
          item.Fabric !== "" &&
          item.Lining !== "" &&
          item.Sheer !== ""
        ) {
          count++;
        }
        if (
          item.Width > 0 &&
          item.Width <= 1000 &&
          item.Drop > 270 &&
          item.Drop <= 1000 &&
          item.Type !== ""
        ) {
          count++;
        }
      });
      return count;
    },
    numOfReadyMadeCurtains() {
      return this.readyMadeCurtainsData.filter(item => item.Price > 0).length;
    },
    numOfcompleteSets() {
      let count = 0;
      count += this.cusMadeBlindsData.filter(item => item.Price > 0).length;
      count += this.readyMadeCurtainsData.filter(item => item.Price > 0).length;
      this.cusMadeCurtainsData.forEach(item => {
        if (
          item.Width > 0 &&
          item.Width <= 1000 &&
          item.Drop > 0 &&
          item.Drop <= 270 &&
          item.Type !== "" &&
          item.Fabric !== "" &&
          item.Lining !== "" &&
          item.Sheer !== ""
        ) {
          count++;
        }
      });
      return count;
    },
    numOfNeedConfirmCurtains() {
      let count = 0;
      this.cusMadeCurtainsData.forEach(item => {
        if (
          item.Width > 0 &&
          item.Width <= 1000 &&
          item.Drop > 270 &&
          item.Drop <= 1000 &&
          item.Type !== "" &&
          item.Fabric !== "" &&
          item.Lining !== "" &&
          item.Sheer !== ""
        ) {
          count++;
        }
      });
      return count;
    },
    totalPrice() {
      let total = 0;
      this.cusMadeBlindsData.forEach(item => {
        if (item.Price !== 0) {
          total += parseFloat(item.Price);
        }
      });
      this.cusMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          total += parseFloat(item.Price);
        }
      });
      this.readyMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          total += parseFloat(item.Price);
        }
      });

      return total.toFixed(2);
    }
  },
  methods: {
    focusName(){
      this.$refs.name.$refs.input.style.borderColor="";
    },
    focusEmail(){
      this.$refs.email.$refs.input.style.borderColor="";
    },
    updateCurtainAfterChangeQuotaition(PDForEmail) {
      this.curtainList = [];
      if (PDForEmail === 0) {
        this.$store.commit("resetState");
      } else {
        this.$store.commit("resetEmailState");
      }

      this.cusMadeBlindsData.forEach(item => {
        if (item.Price !== 0) {
          const newCurtain = {};

          newCurtain.RoomName = item.Window;
          newCurtain.CurtainDrop = item.Drop;
          newCurtain.CurtainWidth = item.Width;
          newCurtain.ModelName = "Custom Made Blinds";
          newCurtain.Type = item.Type;
          newCurtain.Price = item.Price;
          this.curtainList.push(newCurtain);
        }
      });
      this.cusMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          const newCurtain = {};
          newCurtain.RoomName = item.Window;
          newCurtain.CurtainDrop = item.Drop;
          newCurtain.CurtainWidth = item.Width;
          newCurtain.FabricType = item.Fabric;
          newCurtain.TrackType = item.Type;
          newCurtain.Lining = item.Lining;
          newCurtain.Sheer = item.Sheer;
          newCurtain.Price = item.Price;
          newCurtain.ModelName = "Custom Made Curtains";
          this.curtainList.push(newCurtain);
        }
      });
      this.readyMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          const newCurtain = {};
          newCurtain.RoomName = item.Window;
          newCurtain.FabricType = item.Fabric;
          newCurtain.Size = item.Size;
          newCurtain.Price = item.Price;
          newCurtain.ModelName = "Ready Made Curtains";
          this.curtainList.push(newCurtain);
        }
      });
    },
    EmailQuotation() {
      let cusCurtains = 0;
      this.cusMadeBlindsData.forEach(item => {
        if (item.Price !== 0) {
          cusCurtains++;
        }
      });
      this.cusMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          cusCurtains++;
        }
      });
      this.readyMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          cusCurtains++;
        }
      });

      if (cusCurtains === 0) {
        this.$message.error("Oops! There is no quotation!");
        this.dialogVisible=false;
        this.dialogVisiblelg=false;
        return;
      }
      if (!this.userInformation.Email || this.userInformation.Email === "") {
        this.$message.error("Please Input Email Address,Thanks!");
       this.$refs.email.$refs.input.style.borderColor="red";
        this.dialogVisible=false;
         this.dialogVisiblelg=false;
        return;
      }
      if (!this.userInformation.Name || this.userInformation.Name === "") {
        this.$message.error("Please Input Your Name,Thanks!");
         this.dialogVisible=false;
          this.dialogVisiblelg=false;
        return;
      }
      if (this.userInformation.Name !== "") {
        if (this.userInformation.Email === "") {
          this.$message.error("Please Input Email Address,Thanks!");
           this.dialogVisible=false;
            this.dialogVisiblelg=false;
        } else if (!isvalidEmail(this.userInformation.Email)) {
          this.$message.error("Please Input Correct Email Address,Thanks!");
           this.dialogVisible=false;
            this.dialogVisiblelg=false;
        } else {
          const newCustomer = {};
          newCustomer.CurtainCustomerId = localStorage.getItem(
            "curtain_customerId"
          );
          newCustomer.CustomerName = this.userInformation.Name;
          newCustomer.CustomerPhone = this.userInformation.PhoneNumber;
          newCustomer.CustomerAddress = this.userInformation.Address;
          newCustomer.CustomerEmail = this.userInformation.Email;
          regCustomer(newCustomer)
            .then(res => {
              if (res.data.Success) {
                if (
                  this.$store.state.emailSent &&
                  this.$store.state.curtainChanged
                ) {
                  this.$nextTick(() => {
                    getCurtainQuoationId()
                      .then(res => {
                        localStorage.setItem("curtain_quoationId", res.data);
                        this.updateCurtainAfterChangeQuotaition(1);
                        const CurtainQuoationId = localStorage.getItem(
                          "curtain_quoationId"
                        );
                        const CurtainCustomerId = localStorage.getItem(
                          "curtain_customerId"
                        );
                        this.$nextTick(() => {
                          addCurtainLists(
                            this.curtainList,
                            CurtainQuoationId,
                            CurtainCustomerId
                          )
                            .then(res => {
                              if (res.data.Success) {
                                emailQuotationPDF(
                                  CurtainQuoationId,
                                  CurtainCustomerId
                                )
                                  .then(res => {
                                    if (res.data.Success) {
                                      this.$alert(
                                        'The curtain quotation has been emailed to you. Please note that it may go to the "Spam" folder',
                                        "Success!",
                                        {
                                          confirmButtonText: "Ok"
                                        }
                                      );
                                    }
                                    this.$store.commit("resetEmailState");
                                    this.$store.commit("sendEmail");
                                     this.dialogVisible=false;
                                      this.dialogVisiblelg=false;
                                  })
                                  .catch(err => {
                                    this.$message.error(
                                      "something wrong when get the data:" + err
                                    );
                                     this.dialogVisible=false;
                                      this.dialogVisiblelg=false;
                                  });
                              }
                            })
                            .catch(err => {
                              this.$message.error(
                                "something wrong when get the data:" + err
                              ); 
                              this.dialogVisible=false;
                               this.dialogVisiblelg=false;
                          });
                        });
                      })

                      .catch(err => {
                        this.$message.error(
                          "something wrong when get the data:" + err
                        );
                         this.dialogVisible=false;
                          this.dialogVisiblelg=false;
                      });
                  });
                } else {
                  const CurtainQuoationId = localStorage.getItem(
                    "curtain_quoationId"
                  );
                  const CurtainCustomerId = localStorage.getItem(
                    "curtain_customerId"
                  );
                  emailQuotationPDF(CurtainQuoationId, CurtainCustomerId)
                    .then(res => {
                      if (res.data.Success) {
                        this.$alert(
                          'The curtain quotation has been emailed to you. Please note that it may go to the "Spam" folder',
                          "Success!",
                          {
                            confirmButtonText: "Ok"
                          }
                        );
                      }
                      this.$store.commit("resetEmailState");
                      this.$store.commit("sendEmail");
                       this.dialogVisible=false;
                        this.dialogVisiblelg=false;
                    })
                    .catch(err => {
                      this.$message.error(
                        "something wrong when get the data:" + err
                      );
                       this.dialogVisible=false;
                        this.dialogVisiblelg=false;
                    });
                }
              }
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
               this.dialogVisible=false;
                this.dialogVisiblelg=false;
            });
        }
      }
    },
    saveQuotationAsPDF() {
      let cusCurtains = 0;
      this.cusMadeBlindsData.forEach(item => {
        if (item.Price !== 0) {
          cusCurtains++;
        }
      });
      this.cusMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          cusCurtains++;
        }
      });
      this.readyMadeCurtainsData.forEach(item => {
        if (item.Price !== 0) {
          cusCurtains++;
        }
      });

      if (cusCurtains === 0) {
        this.$message.error("Oops! There is no quotation!");
         this.dialogVisible=false;
          this.dialogVisiblelg=false;
        return;
      }
      if (this.userInformation.Name && this.userInformation.Name !== "") {
        const newCustomer = {};
        newCustomer.CurtainCustomerId = localStorage.getItem(
          "curtain_customerId"
        );
        newCustomer.CustomerName = this.userInformation.Name;
        newCustomer.CustomerPhone = this.userInformation.PhoneNumber;
        newCustomer.CustomerAddress = this.userInformation.Address;
        if (
          this.userInformation.Email &&
          this.userInformation.Email !== "" &&
          isvalidEmail(this.userInformation.Email)
        ) {
          newCustomer.CustomerEmail = this.userInformation.Email;
        } else {
          newCustomer.CustomerEmail = "";
        }
        regCustomer(newCustomer)
          .then(res => {
            if (res.data.Success) {
              if (
                this.$store.state.quotationSaved &&
                this.$store.state.curtainChanged
              ) {
                this.$nextTick(() => {
                  getCurtainQuoationId()
                    .then(res => {
                      localStorage.setItem("curtain_quoationId", res.data);
                      this.updateCurtainAfterChangeQuotaition(0);
                      const CurtainQuoationId = localStorage.getItem(
                        "curtain_quoationId"
                      );
                      const CurtainCustomerId = localStorage.getItem(
                        "curtain_customerId"
                      );
                      this.$nextTick(() => {
                        addCurtainLists(
                          this.curtainList,
                          CurtainQuoationId,
                          CurtainCustomerId
                        )
                          .then(res => {
                            if (res.data.Success) {
                              saveQuotationPDF(
                                CurtainQuoationId,
                                CurtainCustomerId
                              )
                                .then(res => {
                                  this.quotationPDF = res.data;
                                   this.dialogVisible=false;
                                    this.dialogVisiblelg=false;
                                  window.open(
                                    this.quotationPDF,
                                    "newwindow",
                                    "height=600,width=1000,top=100,left=200,toolbar=no,menubar=no,scrollbars=yes, resizable=yes,location=no, status=no"
                                  );
                                  this.$store.commit("resetState");
                                  this.$store.commit("saveQuotation");
                                })
                                .catch(err => {
                                  this.$message.error(
                                    "something wrong when get the data:" + err
                                  );
                                   this.dialogVisible=false;
                                    this.dialogVisiblelg=false;
                                });
                            }
                          })
                          .catch(err => {
                            this.$message.error(
                              "something wrong when get the data:" + err
                            );
                             this.dialogVisible=false;
                              this.dialogVisiblelg=false;
                          });
                      });
                    })

                    .catch(err => {
                      this.$message.error(
                        "something wrong when get the data:" + err
                      );
                       this.dialogVisible=false;
                        this.dialogVisiblelg=false;
                    });
                });
              } else {
                const CurtainQuoationId = localStorage.getItem(
                  "curtain_quoationId"
                );
                const CurtainCustomerId = localStorage.getItem(
                  "curtain_customerId"
                );
                saveQuotationPDF(CurtainQuoationId, CurtainCustomerId)
                  .then(res => {
                    this.quotationPDF = res.data;
                     this.dialogVisible=false;
                      this.dialogVisiblelg=false;
                    window.open(
                      this.quotationPDF,
                      "newwindow",
                      "height=600,width=1000,top=100,left=200,toolbar=no,menubar=no,scrollbars=yes, resizable=yes,location=no, status=no"
                    );

                    this.$store.commit("resetState");
                    this.$store.commit("saveQuotation");
                  })
                  .catch(err => {
                    this.$message.error(
                      "something wrong when get the data:" + err
                    );
                     this.dialogVisible=false;
                      this.dialogVisiblelg=false;
                  });
              }
            }
          })
          .catch(err => {
            this.$message.error("something wrong when get the data:" + err);
             this.dialogVisible=false;
              this.dialogVisiblelg=false;
          });
      } else {
        this.$message.error("Please input your Name, thanks");
         this.$refs.name.$refs.input.style.borderColor="red";
         this.dialogVisible=false;
          this.dialogVisiblelg=false;
      }
    }
  }
};
</script>
<style>
.box-card {
  border-radius: 5px;
}
.summary {
  font-size: 14px;
  line-height: 18px;
}
.banner {
  width: 100%;
  height: 100%;
}
.iflogo {
  float: left;
  width: 30%;
}
.content {
  float: left;
  width: 70%;
  text-align: left;
}
.content-title {
  padding: 0;
  margin: 0;
  font-weight: 300;
}
.dialog-footer{
  text-align: left;
 
}
</style>



// WEBPACK FOOTER //
// src/components/UserInfo.vue